import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import RegisterFirstStep from "./RegisterFirstStep";
import RegisterSecondStep from "./RegisterSecondStep";
import { DateObject } from "react-multi-date-picker";
import gregorian from "react-date-object/calendars/gregorian";
import gregorian_en from "react-date-object/locales/gregorian_en";
import toast from "react-hot-toast";
import {
  setRegisterCurrentStep,
  setSuggestedUserData,
} from "../../assets/redux/actions/User";
import UsersRequests from "../../assets/services/user";

const Register = () => {
  const {
    registerCurrStep,
    checkUserInfo,
    loadingRegister,
    suggestedUserData,
  } = useSelector(({ user }) => user);
  const dispatch = useDispatch();
  const dateFormat = {
    date: new Date(),
    gregorian: new DateObject({
      date: new Date(),
      format: "YYYY/MM/DD",
    })
      .convert(gregorian, gregorian_en)
      .format(),
  };

  // first Step fields
  const [personalCode, setpersonalCode] = useState("");
  const [name, setname] = useState("");
  const [familyName, setFamilyName] = useState("");
  const [relation, setrelation] = useState("");
  // second Step fields
  const [birthDay, setBirthDay] = useState(dateFormat);
  const [cooperation, setCooperation] = useState("");
  const [gender, setGender] = useState("");

  const getAssociationType = (type) => {
    if (type === "personnel") {
      return "پرسنل";
    } else if (type === "retired") {
      return "بازنشسته";
    } else if (type === "contractor") {
      return "پیمانکار";
    } else if (type === "saba") {
      return "فولاد صبا";
    }
  };

  useEffect(() => {
    if (suggestedUserData) {
      setpersonalCode(suggestedUserData.personnelCode);
      setrelation(suggestedUserData.relation);
      setGender(suggestedUserData.gender === "female" ? "زن" : "مرد");
      setCooperation(getAssociationType(suggestedUserData.associationType));
    }
    return () => {
      dispatch(setSuggestedUserData(null));
    };
  }, [suggestedUserData]);

  const handleChangeStep = (stepNum) => {
    if (stepNum === 1) {
      if (personalCode && name && familyName && relation) {
        dispatch(setRegisterCurrentStep(1));
      } else {
        toast.error("وارد کردن تمامی موارد الزامی میباشد");
      }
    } else {
      dispatch(setRegisterCurrentStep(0));
    }
  };

  const handleRegister = () => {
    if (birthDay && cooperation && gender) {
      let userData = {
        personnelCode: personalCode,
        relation: relation,
        fullName: name + " " + familyName,
        nationalCode: checkUserInfo.nationalCode,
        phone: checkUserInfo.phone,
        gender: gender === "مرد" ? "male" : "female",
        associationType:
          cooperation === "پرسنل"
            ? "personnel"
            : cooperation === "بازنشسته"
            ? "retired"
            : cooperation === "فولاد صبا"
            ? "saba"
            : "contractor",
        birthDate: birthDay.gregorian.replace(/\//g, "-"),
      };
      dispatch(UsersRequests.registerUser(userData));
    } else {
      toast.error("وارد کردن تمامی موارد الزامی میباشد");
    }
  };

  return registerCurrStep === 0 ? (
    <RegisterFirstStep
      personalCode={personalCode}
      name={name}
      familyName={familyName}
      relation={relation}
      setpersonalCode={setpersonalCode}
      setname={setname}
      setFamilyName={setFamilyName}
      setrelation={setrelation}
      handleChageStep={() => handleChangeStep(1)}
    />
  ) : (
    <RegisterSecondStep
      birthDay={birthDay}
      setBirthDay={setBirthDay}
      cooperation={cooperation}
      setCooperation={setCooperation}
      gender={gender}
      setGender={setGender}
      loading={loadingRegister}
      handleRegister={handleRegister}
    />
  );
};

export default Register;
